import moment, { Moment } from "moment";

/**
 * Formats a given UTC timestamp to display in local time only the time.
 * @param timestamp The timestamp to format.
 */
function formatTime(timestamp: string | Moment | Date): string {
  const m = moment.utc(timestamp);

  return m.local().format("LT");
}

/**
 * Formats a given UTC timestamp to display in local time only the date.
 * @param timestamp The timestamp to format.
 */
function formatDate(timestamp: string | Moment | Date): string {
  const m = moment.utc(timestamp);

  return m.local().format("LL");
}

/**
 * Formats a given UTC timestamp to display in local time using the specified format
 * @param timestamp
 */
function formatDateCustom(timestamp: string | Moment | Date, formatString: string): string {
  const m = moment.utc(timestamp);

  return m.local().format(formatString);
}

/**
 * Formats a given UTC timestamp to display in local time the date and time.
 * @param timestamp The timestamp to format.
 */
function formatDateTime(timestamp: string | Moment | Date): string {
  const m = moment.utc(timestamp);

  return `${formatDate(m)} ${formatTime(m)}`;
}

/**
 * Formats a given UTC timestamp using the specified format.
 * DOES NOT CONVERT TO LOCAL TIME
 * @param timestamp
 */
function formatUnconvertedDateCustom(timestamp: string | Moment | Date, formatString: string): string {
  const m = moment(timestamp);

  return m.format(formatString);
}

export { formatDate, formatDateCustom, formatDateTime, formatTime, formatUnconvertedDateCustom };
